import { defineMessages } from 'react-intl';

const messages = defineMessages({
  installDescription: {
    id: 'context.pwaInstallPrompt.installDescription',
    defaultMessage:
      'This web app has the same functionalities as the mobile app. Add the Icon to your Home screen and use it the same as any other app - just better!',
  },
  installTitle: {
    id: 'pwaInstallPromptContext.installTitle',
    defaultMessage: 'Add to Home Screen',
  },
  installButton: {
    id: 'context.pwaInstallPrompt.installButton',
    defaultMessage: 'Install',
  },
  close: {
    id: 'context.pwaInstallPrompt.close',
    defaultMessage: 'Close',
  },
  stepAddToHomeScreen: {
    id: 'context.pwaInstallPrompt.stepAddToHomeScreen',
    defaultMessage: "Press 'Add to Home Screen'",
  },
  stepShare: {
    id: 'context.pwaInstallPrompt.stepShare',
    defaultMessage: "Press the 'Share' button on the menu bar",
  },
});

export default messages;
